module.exports = __webpack_public_path__ + "files/8e598954fa69f3f346c6ec2a4de72300.png";